#import "../ChartOfAccountFields.graphql"

mutation ChartOfAccountUpdate($input: ChartOfAccountUpdateInput!) {
  chartOfAccountUpdate(input: $input) {
    chartOfAccount {
      ...ChartOfAccountFields
    }
  }
}
